import removeNum from "@/filters/removeNum";
import Vue from "vue";

Vue.use(removeNum);
